import { Message } from '@messageformat/react';
import { IconHousing, IconStreaming } from '@op/opds.opux-icons/expenses';
import { IconForest } from '@op/opds.opux-icons/service';
import { IconForex, IconInterest, IconStock } from '@op/opds.opux-icons/finance';
import {
  IconDevicePhone,
  IconDiagnosis,
  IconFolder,
  IconInternational,
  IconRadar,
  IconRepair,
  IconTrain,
} from '@op/opds.opux-icons/misc';

export const tab1Products = [
  {
    id: 1,
    name: <Message id="course7.task1.products.tab1.product1.name" />,
    type: 'stock',
    description: undefined,
    icon: <IconStock size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 2,
    name: <Message id="course7.task1.products.tab1.product2.name" />,
    type: 'fixedincome',
    description: undefined,
    icon: <IconInterest size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 3,
    name: <Message id="course7.task1.products.tab1.product3.name" />,
    type: 'fixedincome',
    description: undefined,
    icon: <IconInterest size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 4,
    name: <Message id="course7.task1.products.tab1.product4.name" />,
    type: 'fixedincome',
    description: undefined,
    icon: <IconInterest size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 5,
    name: <Message id="course7.task1.products.tab1.product5.name" />,
    type: 'alternative',
    description: undefined,
    icon: <IconHousing size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 6,
    name: <Message id="course7.task1.products.tab1.product6.name" />,
    type: 'alternative',
    description: undefined,
    icon: <IconForest size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
];

export const tab2Products = [
  {
    id: 7,
    name: <Message id="course7.task1.products.tab2.product7.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab2.product7.description" />,
    icon: <IconDevicePhone size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 8,
    name: <Message id="course7.task1.products.tab2.product8.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab2.product8.description" />,
    icon: <IconHousing size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 9,
    name: <Message id="course7.task1.products.tab2.product9.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab2.product9.description" />,
    icon: <IconRepair size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 10,
    name: <Message id="course7.task1.products.tab2.product10.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab2.product10.description" />,
    icon: <IconDevicePhone size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 11,
    name: <Message id="course7.task1.products.tab2.product11.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab2.product11.description" />,
    icon: <IconTrain size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 12,
    name: <Message id="course7.task1.products.tab2.product12.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab2.product12.description" />,
    icon: <IconForex size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
];

export const tab3Products = [
  {
    id: 13,
    name: <Message id="course7.task1.products.tab3.product13.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab3.product13.description" />,
    icon: <IconInternational size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 14,
    name: <Message id="course7.task1.products.tab3.product14.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab3.product14.description" />,
    icon: <IconRadar size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 15,
    name: <Message id="course7.task1.products.tab3.product15.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab3.product15.description" />,
    icon: <IconRepair size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 16,
    name: <Message id="course7.task1.products.tab3.product16.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab3.product16.description" />,
    icon: <IconDiagnosis size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 17,
    name: <Message id="course7.task1.products.tab3.product17.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab3.product17.description" />,
    icon: <IconFolder size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
  {
    id: 18,
    name: <Message id="course7.task1.products.tab3.product18.name" />,
    type: 'stock',
    description: <Message id="course7.task1.products.tab3.product18.description" />,
    icon: <IconStreaming size="large" />,
    instruments: [],
    locations: [],
    fields: [],
  },
];

export const riskProfiles = [
  {
    id: 1,
    name: 'course7.task1.riskprofile1.name',
    description: 'course7.task1.riskprofile1.description',
    icon: <IconStock size="large" />,
    instruments: [],
    locations: [],
    data: [
      {
        label: 'course7.task1.riskprofileGroups.FixedIncomeInvestment',
        value: 100,
        type: 'fixedincome',
      },
      {
        label: 'course7.task1.riskprofileGroups.StockInvestment',
        value: 0,
        type: 'stock',
      },
      {
        label: 'course7.task1.riskprofileGroups.AlternativeInvestment',
        value: 0,
        type: 'alternative',
      },
    ],
  },
  {
    id: 2,
    name: 'course7.task1.riskprofile2.name',
    description: 'course7.task1.riskprofile2.description',
    icon: <IconStock size="large" />,
    instruments: [],
    locations: [],
    data: [
      {
        label: 'course7.task1.riskprofileGroups.FixedIncomeInvestment',
        value: 65,
        type: 'fixedincome',
      },
      {
        label: 'course7.task1.riskprofileGroups.StockInvestment',
        value: 20,
        type: 'stock',
      },
      {
        label: 'course7.task1.riskprofileGroups.AlternativeInvestment',
        value: 15,
        type: 'alternative',
      },
    ],
  },
  {
    id: 3,
    name: 'course7.task1.riskprofile3.name',
    description: 'course7.task1.riskprofile3.description',
    icon: <IconStock size="large" />,
    instruments: [],
    locations: [],
    data: [
      {
        label: 'course7.task1.riskprofileGroups.FixedIncomeInvestment',
        value: 35,
        type: 'fixedincome',
      },
      {
        label: 'course7.task1.riskprofileGroups.StockInvestment',
        value: 50,
        type: 'stock',
      },
      {
        label: 'course7.task1.riskprofileGroups.AlternativeInvestment',
        value: 15,
        type: 'alternative',
      },
    ],
  },
  {
    id: 4,
    name: 'course7.task1.riskprofile4.name',
    description: 'course7.task1.riskprofile4.description',
    icon: <IconStock size="large" />,
    instruments: [],
    locations: [],
    data: [
      {
        label: 'course7.task1.riskprofileGroups.FixedIncomeInvestment',
        value: 5,
        type: 'fixedincome',
      },
      {
        label: 'course7.task1.riskprofileGroups.StockInvestment',
        value: 80,
        type: 'stock',
      },
      {
        label: 'course7.task1.riskprofileGroups.AlternativeInvestment',
        value: 15,
        type: 'alternative',
      },
    ],
  },
  {
    id: 5,
    name: 'course7.task1.riskprofile5.name',
    description: 'course7.task1.riskprofile5.description',
    icon: <IconStock size="large" />,
    instruments: [],
    locations: [],
    data: [
      {
        label: 'course7.task1.riskprofileGroups.FixedIncomeInvestment',
        value: 0,
        type: 'fixedincome',
      },
      {
        label: 'course7.task1.riskprofileGroups.StockInvestment',
        value: 100,
        type: 'stock',
      },
      {
        label: 'course7.task1.riskprofileGroups.AlternativeInvestment',
        value: 0,
        type: 'alternative',
      },
    ],
  },
];

export const investmentProfiles = [
  {
    id: 1,
    data: [
      {
        label: 'course7.exemplaryInvestors.equities',
        value: 80,
        type: 'stock',
      },
      {
        label: 'course7.exemplaryInvestors.etfs',
        value: 15,
        type: 'stock',
      },
      {
        label: 'course7.exemplaryInvestors.equityFunds',
        value: 5,
        type: 'stock',
      },
    ],
  },
  {
    id: 2,
    data: [
      {
        label: 'course7.exemplaryInvestors.equityFunds',
        value: 85,
        type: 'stock',
      },
      {
        label: 'course7.exemplaryInvestors.forestInvestmentFunds',
        value: 15,
        type: 'alternative',
      },
    ],
  },
  {
    id: 3,
    data: [
      {
        label: 'course7.exemplaryInvestors.equityFunds',
        value: 50,
        type: 'stock',
      },
      {
        label: 'course7.exemplaryInvestors.interestRateFunds',
        value: 10,
        type: 'fixedincome',
      },
      {
        label: 'course7.exemplaryInvestors.realEstateFund',
        value: 10,
        type: 'alternative',
      },
      {
        label: 'course7.exemplaryInvestors.etfs',
        value: 10,
        type: 'stock',
      },
      {
        label: 'course7.exemplaryInvestors.stocks',
        value: 20,
        type: 'stock',
      },
    ],
  },
  {
    id: 4,
    data: [
      {
        label: 'course7.exemplaryInvestors.balancedFund',
        value: 100,
        type: 'stock',
      },
    ],
  },
  {
    id: 5,
    data: [
      {
        label: 'course7.exemplaryInvestors.fixedIncomeFunds',
        value: 80,
        type: 'fixedincome',
      },
      {
        label: 'course7.exemplaryInvestors.balancedFunds',
        value: 20,
        type: 'fixedincome',
      },
    ],
  },
];
